import styled from "styled-components/macro";

export const TableWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 340px);
  }

  .table-height-wrapper {
    height: calc(100vh - 143px) !important;
  }

  .talent-agencies-table {
    height: calc(100vh - 169px) !important;
  }

  .scroll-container {
    width: 100%;
    height: calc(100vh - 274px);
    overflow-x: auto;
    white-space: nowrap;
    scroll-behavior: smooth;

    &.subscription-usage-history-table {
      height: calc(100vh - 532px);
    }

    &.table-striped {
      height: calc(100vh - 282px) !important;
    }

    &.common-table {
      height: calc(100vh - 112px);
    }

    /* custom scrollbar */
    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: var(--Neutral-300);
      border: 1px solid transparent;
      background-clip: content-box;
    }
  }

  table {
    width: max-content !important;
    border-collapse: collapse;
    table-layout: auto;

    &.table-wrapper-styles {
      width: 100% !important;
    }

    ${(props) =>
      props.hoveredColumnIndex >= 0 &&
      `
      th:nth-child(${props.hoveredColumnIndex + 1}) .sort-icon {
        opacity: 1;
      }
    `}

    .sort-icon {
      opacity: 1;
      transition: opacity 0.2s ease;
    }

    thead {
      tr {
        border-radius: 8px 0 0 0;
        border-bottom: 1px solid var(--Neutral-8);
        height: 40px;
        background: var(
          --Neutral-2,
          linear-gradient(
            0deg,
            rgba(31, 31, 31, 0.02) 0%,
            rgba(31, 31, 31, 0.02) 100%
          ),
          #fff
        );
        position: sticky;
        top: 0;
        z-index: 3;
      }

      th {
        padding: 8px 12px;
        color: var(--Neutral-100);
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.021px;
        text-align: left;
        position: relative;
        transition: border-color 0.2s ease;
        overflow: hidden;
        z-index: 1;

        .header-content-reverse {
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          gap: 6px;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 6px;

          &.mono {
            flex-direction: row-reverse;
          }
        }

        /* Column Resize Handle */
        .table__resize-handle {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 8px;
          height: 24px;
          cursor: col-resize;
          user-select: none;
          touch-action: none;
          background: transparent;
          z-index: 5;
          border-radius: 1px;
          transition: background 0.2s ease;

          &::after {
            content: "";
            position: absolute;
            left: 2px;
            width: 2px;
            top: 0;
            bottom: 0;
            background: transparent;
            transition: background 0.2s ease;
            border-radius: 1px;
          }
        }

        &:hover .table__resize-handle::after,
        .table__resize-handle.isResizing::after {
          background: linear-gradient(
            0deg,
            rgba(0, 124, 221, 0.4) 0%,
            rgba(0, 124, 221, 0.4) 100%
          );
        }

        .truncate-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &.mono {
          text-align: right;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid var(--Neutral-4);
        height: 48px;
        position: relative;

        td {
          padding: 0 12px;
          color: var(--Neutral-100);
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .link-text-pointer {
            text-decoration: underline;
            cursor: pointer;
          }

          &.creator-cell {
            text-transform: capitalize;
          }

          &.creator-handle {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 120px;

            .handle-link {
              text-decoration: underline;
              text-underline-offset: 2px;
              cursor: pointer;
            }
          }

          a {
            color: var(--Neutral-100);
          }

          .status-count {
            &:hover {
              text-decoration: underline;
            }
          }
          .type-badge {
            padding: 4px 8px;
            border-radius: 24px;
          }

          .hover-btn-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 4px;
            justify-content: flex-end;
          }

          .truncate-text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .company-cell {
            display: flex;
            align-items: center;
            gap: 8px;
            height: 32px;

            .placeholder-logo {
              border-radius: 50%;
              background: var(--Brand-8);
              padding: 6px;
              display: flex;
              align-items: center;

              svg {
                height: 20px;
                width: 20px;
              }
            }

            .user-fallback-img {
              display: block !important;
            }

            img {
              display: flex;
              width: 32px;
              height: 32px;
              justify-content: center;
              align-items: center;
              aspect-ratio: 1/1;
              border-radius: 50%;
            }
          }

          &.actions {
            position: sticky;
            right: -1px;
            z-index: 2;
            padding: 0 12px 0 0;
            opacity: 0;
            transition: opacity 0.2s ease;
            background: var(--Neutral-4);
          }

          .hover-actions {
            padding: 10px;
            cursor: pointer;
            height: 40px;
            border-radius: 50%;

            &:hover {
              background: var(--White-100);
            }

            svg {
              width: 20px;
              height: 20px;
              cursor: pointer;
            }
          }

          .status-pill {
            padding: 4px 8px;
            border-radius: 24px;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: -0.012px;
            text-transform: capitalize;
            height: 24px;
            display: flex;
            align-items: center;
            width: max-content;
          }

          &.mono {
            font-family: "DM Mono", monospace;
            text-align: right;
          }

          .table-link {
            display: block;
            /* max-width: 150px; */
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            white-space: nowrap;

            a {
              color: var(--Brand-100);
              text-decoration-line: underline;
              text-decoration-style: solid;
              text-decoration-skip-ink: auto;
              text-decoration-thickness: auto;
              text-underline-offset: auto;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: -0.014px;
            }
          }
        }

        &:hover {
          background-color: var(--Neutral-4);

          td {
            &.actions {
              opacity: 1; /* show hover actions */
            }
          }
        }
      }
    }
  }
`;
